var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTrashRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.85375 33.4587H23.52C25.185 33.4587 26.54 32.1037 26.54 30.4387V10.125H29.875V7.41625H23.2087V3.77125C23.2087 2.105 21.8538 0.75 20.1875 0.75H10.1875C8.52125 0.75 7.16625 2.105 7.16625 3.77125V7.4175H0.5V10.125H3.83375V30.4375C3.83375 32.1037 5.18875 33.4587 6.85375 33.4587ZM9.875 3.45875H20.5V7.4175H9.875V3.45875ZM6.54125 10.125H23.8325L23.835 30.75H6.54125V10.125Z",
    fill: "#D32F2F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.8748 14.0837H17.166V26.7925H19.8748V14.0837Z",
    fill: "#D32F2F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.2087 14.0837H10.5V26.7925H13.2087V14.0837Z",
    fill: "#D32F2F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrashRed);
export default __webpack_public_path__ + "static/media/icon-trash-red.4dc7cbd93a9a06020ece9a82d94a9b7b.svg";
export { ForwardRef as ReactComponent };